import { type IframeMapProp } from "./iframMap.type";

export const IframeMap = ({ latLng, h, w }: IframeMapProp) => {
    const { lat, lng } = latLng;

    return (
        <iframe
            width={w}
            height={h}
            title="accommodation_location"
            id="iframeMap"
            src={`https://marginauto.kr/naverMap.html?lat=${lat}&lng=${lng}`}
        />
    );
};
